import { MovingSpriteView } from '../../ui_canvas_engine/MovingSpriteView.ts';
export class UIGameMapCornerView extends MovingSpriteView {
    constructor(corner, x, y, w, h, layer, texture, container){
        super(x, y, w, h, container, texture);
        this.zIndex = layer;
        this.corner = corner;
        this.buildingType = corner.buildingType;
    }
}
